/**
 * Selectors
 */
const selectCMSBlocksForPage = (state, blocks) => {
  let lang = state.i18nState.lang;
  return state.cmsblocks.list.filter(
    (block) => blocks.includes(block.slug) && block.language === lang
  );
};

/** exports all actions as default */
const cmsblockSelectors = {
  selectCMSBlocksForPage: selectCMSBlocksForPage,
};

export default cmsblockSelectors;
